export default __webpack_public_path__ + "static/media/power.c6fe0e23.svg";